/**
 * @license lucide-vue-next v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createLucideIcon from '../createLucideIcon.js';

const ZodiacLeo = createLucideIcon("zodiac-leo", [
  [
    "path",
    { d: "M10 16c0-4-3-4.5-3-8a5 5 0 0 1 10 0c0 3.466-3 6.196-3 10a3 3 0 0 0 6 0", key: "1qj6nb" }
  ],
  ["circle", { cx: "7", cy: "16", r: "3", key: "yyv3zl" }]
]);

export { ZodiacLeo as default };
//# sourceMappingURL=zodiac-leo.js.map
